import React from 'react';
import { signatureJSONToSVG } from '../../utils';

const SignatureImage = props => {
  const { SignatureData } = props;

  return (
    <img src={signatureJSONToSVG(SignatureData)} />
  );
};

export default SignatureImage;